import { Tutorial } from '../tutorial.model';

export const GOVERNANCA_TOURS: readonly Tutorial[] = [
  {
    id: 'governanca',
    rota: '/painel/governanca',
    interativo: true,
    passos: [
      { alvo: 'governanca.proposito', titulo: 'Use os indicadores para orientar a revisão financeira',
        corpo: 'Governança reúne indicadores e ocorrências automáticas em uma única tela. Os resultados apontam indícios para investigar; confira os fatos e as limitações antes de concluir uma análise.' },
      { alvo: 'governanca.indicadores', titulo: 'Compare contas a pagar e a receber',
        corpo: 'Cada grupo de cartões mostra o percentual de contas revisadas, quantas estão conciliadas e quantas ficaram sem documento comprobatório. Em Conciliação, o número de não conciliadas leva à conciliação bancária quando você tem acesso a ela.' },
      { alvo: 'governanca.filtros-ocorrencias', titulo: 'Localize os indícios que deseja revisar',
        corpo: 'A pesquisa atualiza a tabela enquanto você digita, sem botão. Use Filtrar para refinar por período, estado, direção, prioridade, código da regra e desfecho; os filtros aplicados aparecem como fichas que podem ser removidas.' },
      { alvo: 'governanca.periodo', titulo: 'Defina o período da consulta',
        corpo: 'Em Filtrar, preencha De e Até. O período vale para os indicadores e para a tabela de ocorrências; por padrão a consulta vai do início do mês até hoje. Confira as datas antes de comparar números.' },
      { alvo: 'governanca.ocorrencias', titulo: 'Priorize a investigação pelo conteúdo da ocorrência',
        corpo: 'Confira Data, Regra, Indício, Prioridade, Valor relacionado e Estado. A paginação permite consultar os demais resultados.' },
      { alvo: 'governanca.acoes', alvoAlternativo: 'governanca.ocorrencias', titulo: 'Investigue ou consulte a conta',
        corpo: 'O ícone de lupa abre a investigação da ocorrência. Ver conta abre o lançamento que originou o alerta, quando disponível para seu acesso.' },
      { alvo: 'governanca.regras', alvoAlternativo: 'governanca.proposito', titulo: 'Gerencie as regras de prevenção',
        corpo: 'Quem tem permissão para configurar Governança encontra aqui a biblioteca de regras, onde é possível ativar, desativar e ajustar pesos e parâmetros.' },
    ],
  },
  {
    id: 'governanca-investigacao',
    rota: '/painel/governanca',
    dialogo: true,
    passos: [
      { alvo: 'governanca-investigacao.resumo', titulo: 'Entenda o indício',
        corpo: 'O resumo traz a regra, o estado, a prioridade e o responsável. A pontuação apenas organiza a fila; a decisão é da revisão humana.' },
      { alvo: 'governanca-investigacao.fatos', titulo: 'Compare fatos e limitações',
        corpo: 'Os fatos verificados mostram o que a regra encontrou; as limitações dizem o que não pôde ser avaliado. Confira também o histórico e os achados sugeridos pela IA, que precisam de conferência.' },
      { alvo: 'governanca-investigacao.revisao', alvoAlternativo: 'governanca-investigacao.fatos', titulo: 'Registre a revisão depois de investigar',
        corpo: 'Escolha o desfecho, registre uma observação e use Concluir análise quando tiver permissão. Assumir análise indica que você é o responsável. A conclusão não altera a conta financeira.' },
    ],
  },
  {
    id: 'governanca-regras',
    rota: '/painel/governanca/regras',
    passos: [
      { alvo: 'governanca-regras.tabela', titulo: 'Consulte a biblioteca de regras',
        corpo: 'Cada linha mostra o código, o nome e a situação da regra. Regras ativas avaliam as contas finalizadas e conciliadas. Uma divergência gera ocorrência para análise.' },
      { alvo: 'governanca-regras.acoes', alvoAlternativo: 'governanca-regras.tabela', titulo: 'Edite ou ative e desative uma regra',
        corpo: 'Editar ajusta o peso e os parâmetros da regra. Ativar ou desativar também publica uma nova versão da política, e a API reavalia o acervo sozinha depois da publicação.' },
    ],
  },
];
